import { z } from 'zod'
import * as validation from '@/helpers/validation'

export const TariffsSchema = 
        z.array(z.object({
          id: validation.id(),
          externalId: z.string().nullable(),
          name: z.string(),
          utilityProviderId: z.number(),
          utilityProviderName: z.string(),
          timeOfUseProfileId: z.number(),
          provinceId: z.number(),
          provinceName: z.string(),
          isTimeOfUse: z.boolean(),
          transZone: z.string().nullable(),
          voltage: z.string().nullable(),
          source: z.string(),
          approvedBy: z.string(),
          createdAt: z.coerce.date(),
          updatedAt: z.coerce.date(),
          periods: z.array(z.object({
            id: validation.id(),
            chargeNameId: z.number(),
            chargeName: z.string(),
            seasonId: z.number(),
            season: z.string(),
            timeOfUseId: z.number(),
            timeOfUse: z.string(),
            isActive: z.boolean(),
            yearOfTariff: z.number(),
            startOfBand: z.number(),
            endOfBand: z.number(),
            bandRateInCents: z.number(),
            oldRateInCents: z.number().nullable(),
            rateChangePercentage: z.number().nullish()
          })).min(1),
          isApproved: z.boolean()
        }))

    export const UtilityProvidersSchema = z.array(z.object({
              id: z.number().int().gt(0),
              name: z.string()
            }))